<ng-container *ngIf="acting">
  <button mat-button disabled (click)="follow()">
    <app-spinner class="text-inline" [inline]="true"></app-spinner>
    {{actingLabel}}
  </button>

</ng-container>
<ng-container *ngIf="!acting">
  <button mat-button [class.follow]="!isFollowed" [class.unfollow]="isFollowed" (click)="isFollowed ? unfollow() : follow()">
    <tyt-follow-icon
      [type]="type"
      [id]="id"
      [followed]="!isFollowed"
      [action]="true"
      ></tyt-follow-icon>
    {{ isFollowed ? unfollowText : followText }}
  </button>
</ng-container>